/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';

// Use this to check for whether Sunshine has multiple conversations or not only if the response from
// the SunshineChannel model is ambiguous. Calling this API will create multiple test conversations in
// Sunshine in order to figure out whether Sunshine has multiple conversations enabled or not.
export default class SunshineMultipleConversation extends Model {
  @attr('boolean') declare enabled: boolean;
}
